let Inits = [
  {
    rightnavs: '元素',
    id: 'gta_ai_event_item',
    title: '',
    content: '。',
    blockText: `<block type="gta_ai_event_item"></block>`,
  },
]
// 事件
let Events = [
  {
    rightnavs: '事件',
    id: 'gta_ai_event_1',
    title: '开始进入Python的世界',
    content:
      '这块积木代表“程序的开端”，并没有实际作用，在Python程序中，它仅仅是一句注释，不会被运行。',
    blockText: `<block type="gta_ai_event_1"></block>`,
  },
  {
    id: 'gta_ai_event_2',
    title: '打印',
    blockText: `<block type="gta_ai_event_2"></block>`,
    content: '可用来打印文本、变量、布尔值、列表等内容显示在终端区。',
  },
  {
    id: 'gta_ai_event_print',
    title: '可嵌套积木的打印',
    blockText: `<block type="gta_ai_event_print">
    <value name="NAME">
      <shadow type="gta_ai_event_item"> </shadow>
    </value>
  </block>`,
    content: '第二个打印积木，可打印嵌套内的积木脚本',
  },
  {
    id: 'gta_ai_event_3',
    title: '注释',
    blockText: `<block type="gta_ai_event_3"></block>`,
    content:
      '注释的代码不会被执行，以#为开头注释在单行中，注释主要为提醒作用，也方便他人轻松解读代码的意思，增加可读性。',
  },
  {
    id: 'gta_ai_event_4',
    title: '执行代码（嵌套）',
    blockText: `<block type="gta_ai_event_4"></block>`,
    content:
      '该积木没有实际的用途。Python是一门非常强大的语言，不能将所有的函数转换成我们使用的积木，当你需要用到这些语句时，可以直接在积木里面编写你需要的函数，计算机即可直接运行您写的所有代码。积木的使用方式需要嵌套在其他积木内生效。',
  },
  {
    id: 'gta_ai_event_5',
    title: '执行代码（不可嵌套）',
    blockText: `<block type="gta_ai_event_5"></block>`,
    content:
      '该积木没有实际的用途。Python是一门非常强大的语言，不能将所有的函数转换成我们使用的积木，当你需要用到这些语句时，可以直接在积木里面编写你需要的函数，计算机即可直接运行您写的所有代码。',
  },
]

// 控制
let Control = [
  {
    rightnavs: '控制',
    id: 'controls_repeat_ext',
    title: '重复执行（）次',
    content:
      '重复执行是一个嵌套的积木，积木中间可以嵌套其他积木，嵌套的积木部分就是循环的内容。\n积木上面的数字为重复执行的次数，执行完毕后，再执行积木下方的脚本。',
    blockText: `<block type="controls_repeat_ext">
    <value name="TIMES">
      <shadow type="math_number">
        <field name="NUM">20</field>
      </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_controls_whileUntil',
    title: '如果…重复执行',
    blockText: `<block type="gta_controls_whileUntil">
    <value name="NAME1">
      <shadow type="logic_null"></shadow>
    </value>
  </block>`,
    content: '如果满足条件，则重复执行嵌套中的代码，如果不满足条件，则不执行。',
  },
  {
    id: 'controls_for',
    title: '变量“i”从_数到_每次增加_',
    blockText: `<block type="controls_for">
    <value name="FROM">
      <shadow type="math_number">
        <field name="NUM">1</field>
      </shadow>
    </value>
    <value name="TO">
      <shadow type="math_number">
        <field name="NUM">10</field>
      </shadow>
    </value>
    <value name="BY">
      <shadow type="math_number">
        <field name="NUM">1</field>
      </shadow>
    </value>
  </block>`,
    content:
      '用变量”i”记录从开始数值到终止数值之间的数值，数值按指定间隔增加，并执行指定的块。',
  },
  {
    id: 'controls_forEach',
    title: '为列表_里的每一项_执行',
    blockText: `<block type="controls_forEach">
    <value name="LIST">
      <block type="variables_get">
        <field name="VAR">{listVariable}</field>
      </block>
    </value>
  </block>`,
    content: '遍历列表中的每一项，将变量“j”设为所选项，并执行一些语句。',
  },
  {
    id: 'break_continue',
    title: '跳出循环',
    blockText: `<block type="break_continue"></block>`,
    content: '跳出包含它的循环；需要注意的是这个块只能在循环内使用。',
  },
  {
    id: 'controls_if',
    title: '如果…那么',
    blockText: `<block type="controls_if">
    <value name="IF0">
      <shadow type="logic_null"></shadow>
    </value>
  </block>`,
    content: '如果满足条件，则执行嵌套中的代码，如果不满足条件，则不执行。',
  },
  {
    id: 'logic_negate',
    title: '非…',
    blockText: `<block type="logic_negate">
    <value name="BOOL">
      <shadow type="logic_null">
        <field></field>
      </shadow>
    </value>
  </block>`,
    content: '如果输入结果为假，则返回真；如果输入结果为真，则返回假。',
  },
  {
    id: 'logic_ternary',
    title: '断言__如果为真，__如果为假__',
    blockText: `<block type="logic_ternary">
    <value name="IF">
      <shadow type="logic_null"></shadow>
    </value>
    <value name="THEN">
      <shadow type="gta_ai_controls_item"></shadow>
    </value>
    <value name="ELSE">
      <shadow type="gta_ai_controls_item"></shadow>
    </value>
  </block>`,
    content:
      '检查“断言”里的条件语句。如果条件为真，则返回“如果为真”的值，否则，则返回“如果为假”的值。',
  },
  {
    id: 'waiting_time',
    title: ' 等待（）秒',
    blockText: `<block type="waiting_time"></block>`,
    content:
      '执行程序时，“等待1秒”，也可理解为“睡眠1秒”，适用于某些情况下需要人为让程序延迟的时候。',
  },
]

// 运算
let Operators = [
  {
    rightnavs: '运算',
    id: 'math_number',
    title: ' 一个数值',
    content: '一个数值，可以输入任意数值。',
    blockText: `<block type="math_number">
          <field name="NUM">123</field>
        </block>`,
  },
  {
    id: 'math_arithmetic_add',
    title: '数字运算',
    blockText: `<block type="math_arithmetic_add">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>`,
    content: '四则运算，对数字进行加减乘除处理，加法还可以把字符串、列表相加。',
  },
  {
    id: 'logic_compare_1',
    title: '比较式',
    blockText: `<block type="logic_compare_1">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '比较表达式为布尔表达式，如果条件成立，则返回True，条件不成立则返回False。',
  },
  {
    id: 'logic_operation',
    title: '逻辑运算',
    blockText: `<block type="logic_operation">
          <value name="A">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>`,
    content:
      ' “并且”两边的条件同时成立，这个布尔表达式才算成立。\n“或”两边只要有一边条件成立，这个布尔值表达式就算成立。',
  },
  {
    id: 'logic_boolean',
    title: '逻辑运算：“非”',
    blockText: `<block type="logic_boolean"></block>`,
    content: '对当前的布尔表达式取反，如果当前表达式成立，则返回的值为不成立。',
  },
  {
    id: 'math_random_int',
    title: '随机整数',
    blockText: `<block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>`,
    content:
      '1到10中随机取一个整数，区间[1,10]，前闭后闭，1和10两个值都有可能随机取到。',
  },
  {
    id: 'math_modulo',
    title: '除法求余数',
    blockText: `<block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '余数指整数除法中被除数未被除尽部分，且余数的取值范围为0到除数之间（不包括除数）的整数。例如：64除以10，商数为6，余数为4。',
  },
  {
    id: 'math_single',
    title: '绝对值',
    blockText: `<block type="math_single">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '绝对值是指一个数在数轴上所对应点到原点的距离，用“| |”来表示。\n正数和0的绝对值为它本身。\n负数的绝对值是它的相反数。',
  },
  {
    id: 'math_trig',
    title: '正弦值',
    blockText: `<block type="math_trig">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>`,
    content: '返回指定角度的正弦值（非弧度）。',
  },
  {
    id: 'math_constant',
    title: '常见值',
    blockText: `<block type="math_constant"></block>`,
    content:
      ' 返回一个常见量：π（3.141…）、e（2.718…）、φ（1.618…）、平方根（1.414…）、开平方根（0.707…）或∞无限大”。',
  },
  {
    id: 'math_number_property',
    title: '检查数值属性',
    blockText: `<block type="math_number_property">
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>`,
    content:
      ' 检查一个数值是否是偶数、奇数、质数、自然数、正数、负数或者是否能被某数整除。返回真或假。',
  },
  {
    id: 'math_round',
    title: '四舍五入',
    blockText: `<block type="math_round">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>`,
    content: '数值小数点后数字向上或向下舍入。',
  },
  {
    id: 'math_random_float',
    title: '随机小数',
    blockText: `<block type="math_random_float"></block>`,
    content: '返回一个介于0.0到1.0之间（含边界）的随机数。',
  },
  {
    id: 'math_on_list',
    title: '列表中数值的和',
    blockText: `<block type="math_on_list">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '返回列表中的所有数值的和。',
  },
  {
    id: 'math_constrain',
    title: '将数值限制在指定数值范围',
    blockText: `<block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>`,
    content: '将一个数值限制在两个指定的数值范围（含边界）之间。',
  },
  {
    id: 'math_atan2',
    title: '反正切值',
    blockText: `<block type="math_atan2">
          <value name="X">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="Y">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>`,
    content: '返回点（X,Y）的反正切值，范围为-180度到180度。',
  },
]

// 字符串
let Text = [
  {
    rightnavs: '字符串',
    id: 'text',
    title: ' 字符串',
    content: '新建一个字符串。',
    blockText: `<block type="text"></block>`,
  },
  {
    id: 'text_join',
    title: '建立文本从__',
    blockText: `<block type="text_join"></block>`,
    content: '通过串起任意数量的项以建立一段文本。',
  },
  {
    id: 'text_length',
    title: '文本的长度',
    blockText: `<block type="text_length">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '返回给定文本的字母数（包括空格）。',
  },
  {
    id: 'gta_ai_variable_change',
    title: '将数字转化为整数',
    blockText: `<block type="gta_ai_variable_change"></block>`,
    content:
      '将文本对象转化为整数类。若输入的不是整数，系统将会报错。“并且”两边的条件同时成立，这个布尔表达式才算成立。',
  },
  {
    id: 'gta_ai_variable_change_2',
    title: '将数字转化为整数2',
    blockText: `<block type="gta_ai_variable_change_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
  </block>`,
    content:
      '将文本对象转化为整数类。若输入的不是整数，系统将会报错。“并且”两边的条件同时成立，这个布尔表达式才算成立。',
  },
  {
    id: 'text_changeCase',
    title: '文字大小写模式',
    blockText: `<block type="text_changeCase">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '用不同的大小写模式复制并返回这段文字。',
  },
  {
    id: 'gta_ai_text_include',
    title: '判断一串字符中是否包含特定字符',
    blockText: `<block type="gta_ai_text_include"></block>`,
    content: '判断前一个空格中的字符是否存在于后面的字符串中。',
  },
  {
    id: 'gta_ai_text_include_2',
    title: '判断一串字符中是否包含特定字符2',
    blockText: `<block type="gta_ai_text_include_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT">Hello</field>
      </shadow>
    </value>
    <value name="NAME2">
      <shadow type="text">
        <field name="TEXT">Hello</field>
      </shadow>
    </value>
  </block>`,
    content: '判断前一个空格中的字符是否存在于后面的字符串中。',
  },
  {
    id: 'text_isEmpty',
    title: '判断文本是否为空',
    blockText: `<block type="text_isEmpty">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>`,
    content: '如果给定的文本为空，则返回真。',
  },
  {
    id: 'text_indexOf',
    title: '文本中寻找第一次/最后一次出现的字符',
    blockText: `<block type="text_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">文本</field>
            </block>
          </value>
          <value name="FIND">
            <shadow type="text">
              <field name="TEXT">abcd</field>
            </shadow>
          </value>
        </block>`,
    content: '寻找文本中第一次/最后一次出现特定的字符串的位置。',
  },
  {
    id: 'lists_split',
    title: '从文本制作列表',
    blockText: `<block type="lists_split">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">文本</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>`,
    content: '将文本分割为列表。',
  },
  {
    id: 'lists_split_1',
    title: '从列表拆出文本',
    blockText: `<block type="lists_split_1">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>`,
    content: '将列表分拼接为文本。',
  },
  {
    id: 'text_getSubstring',
    title: '取得子字符',
    blockText: `<block type="text_getSubstring">
          <value name="STRING">
            <block type="variables_get">
              <field name="VAR">文本</field>
            </block>
          </value>
          <value name="AT1">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="AT2">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content: '获取文本的子字符。',
  },
  {
    id: 'text_append',
    title: '附加文本',
    blockText: `<block type="text_append">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '在文本后面添加文本进去。',
  },
  {
    id: 'text_trim',
    title: '消除其两侧的空白',
    blockText: `<block type="text_trim">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '删除文本两侧的空白符。',
  },
]

// 列表
let List = [
  {
    rightnavs: '列表',
    id: 'lists_create_with',
    title: ' 创建空列表',
    content: '新建一个列表类型数据',
    blockText: `<block type="lists_create_with">
          <mutation items="0"></mutation>
        </block>`,
  },
  {
    id: 'lists_establish_with',
    title: '建立列表从__',
    blockText: `<block type="lists_establish_with">
          <mutation items="2"></mutation>
        </block>`,
    content: '通过串起任意数量的项以建立一个列表',
  },
  {
    id: 'lists_setIndex',
    title: '在列表中设置',
    blockText: `<block type="lists_setIndex">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '设置列表某个索引的值',
  },
  {
    id: 'lists_getIndex',
    title: '在列表中取得',
    blockText: `<block type="lists_getIndex">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取列表某个索引的值',
  },
  {
    id: 'lists_indexOf',
    title: '在列表中寻找第一次出现的项',
    blockText: `<block type="lists_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取列表某个数据第一次出现的索引。',
  },
  {
    id: 'lists_length',
    title: '列表的长度',
    blockText: `<block type="lists_length">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取列表的长度。',
  },
  {
    id: 'lists_getSublist',
    title: '在列表中获取子列表从#',
    blockText: `<block type="lists_getSublist">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取子列表',
  },
  {
    id: 'lists_isEmpty',
    title: '列表是空的',
    blockText: `<block type="lists_isEmpty">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '判断是否空列表。',
  },
  {
    id: 'lists_repeat',
    title: '建立列表使用项',
    blockText: `<block type="lists_repeat">
          <value name="ITEM">
            <block type="text"></block>
          </value>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">5</field>
            </shadow>
          </value>
        </block>`,
    content: '建立列表使用项',
  },
  {
    id: 'gta_ai_lists_include',
    title: '存在于列表',
    blockText: `<block type="gta_ai_lists_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '存在于列表',
  },
  {
    id: 'gta_ai_lists_include_2',
    title: '存在于列表2',
    blockText: `<block type="gta_ai_lists_include_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
    <value name="NAME2">
      <block type="variables_get">
        <field name="VAR">{listVariable}</field>
      </block>
    </value>
  </block>`,
    content: '存在于列表',
  },
  {
    id: 'lists_sort',
    title: '列表排序',
    blockText: `<block type="lists_sort"></block>`,
    content: '列表排序。',
  },
]

// 字典
let Dictionary = [
  {
    rightnavs: '字典',
    id: 'create_dict',
    title: '设置一个键和值',
    content: '分别设置字典的键和值，作为创建字典的键值对属性',
    blockText: `<block type="create_dict"></block>`,
  },
  {
    id: 'dict_create_with',
    title: '创建字典',
    blockText: `<block type="dict_create_with">
          <mutation items="1"></mutation>
        </block>`,
    content: '建立一个字典DT类型的数据，字典属性为键值对映射格式',
  },
  {
    id: 'set_dict',
    title: '设置键与值',
    blockText: `<block type="set_dict"></block>`,
    content: '通过键“nb”查找到对应的值，并且返回值。',
  },
  {
    id: 'gta_ai_get_dict_key',
    title: '读取键名对应的值',
    blockText: `<block type="gta_ai_get_dict_key"></block>`,
    content: '读取某个键的值',
  },
  {
    id: 'length_of_dict',
    title: '键总数',
    blockText: `<block type="length_of_dict"></block>`,
    content: '获取字典DT中键的总数，返回一个整数型数字。',
  },
  {
    id: 'del_dict_key',
    title: '删除字典',
    blockText: `<block type="del_dict_key"></block>`,
    content: ' 删除字典DT的键“nb”以及”nb”对应的值。',
  },
  {
    id: 'del_dict_key_2',
    title: '删除字典2',
    blockText: `      <block type="del_dict_key_2">
    <value name="key">
     <block type="text">
       <field name="TEXT"></field>
     </block>
   </value>
 </block>`,
    content: ' 删除字典DT的键“nb”以及”nb”对应的值。',
  },
  {
    id: 'gta_ai_dict_include',
    title: '键是否存在',
    blockText: `<block type="gta_ai_dict_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">DT</field>
            </block>
          </value>
        </block>`,
    content: '通过键“nb”查找到对应的值，并且返回值。',
  },
  {
    id: 'gta_ai_dict_include_2',
    title: '键是否存在',
    blockText: `<block type="gta_ai_dict_include_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
    <value name="NAME2">
      <block type="variables_get">
        <field name="VAR">DT</field>
      </block>
    </value>
  </block>`,
    content: '通过键“nb”查找到对应的值，并且返回值。',
  },
]

// 变量
let Variable = [
  {
    rightnavs: '变量',
    id: 'variables_set',
    title: '赋值变量',
    blockText: `<block type="variables_set"></block>`,
    content: `AA=0这句赋值语句，不仅给变量赋值了数字0，同时还定义了变量当前的数据类型是数字。数字类型的变量不能直接使用字符串、列表、字典等其他数据类型的数据规则进行改变，否则会报错。

    但是在Python中变量的数据类型是动态的，重新定义便可以改变变量的数据类型，这也是Python语言的一大特点。

    实际上，在代码模式下，AA=0这句短短的代码，同时完成了创建变量、定义变量的数据类型、给变量赋值三项任务。

    提醒：所有的变量都必须有初始赋值的过程，否则直接调用变量会报错哦~`,
  },
  {
    id: 'math_change',
    title: '变量增加',
    content: `变量增加值。`,
    blockText: `<block type="math_change"></block>`,
  },
  {
    id: 'variables_get',
    title: '获取变量',
    blockText: `<block type="variables_get"> </block>`,
    content: `AA=0这句赋值语句，不仅给变量赋值了数字0，同时还定义了变量当前的数据类型是数字。数字类型的变量不能直接使用字符串、列表、字典等其他数据类型的数据规则进行改变，否则会报错。

    但是在Python中变量的数据类型是动态的，重新定义便可以改变变量的数据类型，这也是Python语言的一大特点。

    实际上，在代码模式下，AA=0这句短短的代码，同时完成了创建变量、定义变量的数据类型、给变量赋值三项任务。

    提醒：所有的变量都必须有初始赋值的过程，否则直接调用变量会报错哦~`,
  },
]

// 函数
let Function = [
  {
    rightnavs: '函数',
    id: 'procedures_defnoreturn',
    title: '定义无返回函数',
    content: `含义：
    1. 定义函数时，需要先定义函数的名称，点击上图中字母function所在的区域，就可以编 辑函数名。
    函数名需要满足以下几条规则：
    函数名可以同时包含字母和数字，但不能以数字开头。
    函数名中的字符必须是字母、数字、下划线或者汉字，不能使用其他字符。
    函数名区分大小写。
    函数不可以与关键词同名，同时为了防止一些理解上的误会，在积木模式下数名 不可以与任何Python其他内置函数同名。
    2. 要使用函数，光对函数进行定义可不行哦！函数定义只是构造了这个函数，要使函数真 正发挥作用，还要对函数进行调用，后面的部分会详细讲到如何调用函数。`,
    blockText: `<block type="procedures_defnoreturn"></block>`,
  },
  // {
  //   id: 'procedures_mutatorcontainer',
  //   title: '定义有返回函数',
  //   blockText: `<block type="procedures_mutatorcontainer"></block>`,
  //   content: '函数定义后，要调用它，函数才能发挥它的效果哦。',
  // },
  {
    id: 'procedures_defreturn',
    title: '输出值函数',
    blockText: `<block type="procedures_defreturn"></block>`,
    content: `含义：
    1. 创建一个有输出值的函数。
    2. 要将一个函数结束运行时得出的信息传递给程序的剩余部分，可以使用带“返回”的函数。
    3. 当运行到“返回”时，函数会停止运行，并返回对应表达式的值。
      有返回值的函数是椭圆型的哦，可以塞到其他的积木中，返回值能够被运行。`,
  },
  {
    id: 'procedures_ifreturn',
    title: '如果…..返回…..',
    blockText: `<block type="procedures_ifreturn"></block>`,
    content:
      '如果里面的值判断为真，则返回相关数值。提示：这个块只能在函数内部使用。',
  },
]

// 媒体
let Media = [
  {
    rightnavs: '媒体',
    id: 'play_audio',
    title: '播放音频',
    content: '开始播放音频。',
    blockText: `<block type="play_audio"></block>`,
  },
  {
    id: 'pause_audio',
    title: '停止播放音频',
    blockText: `<block type="pause_audio"> </block>`,
    content: '停止播放音频。',
  },
  {
    id: 'volume_add_audio',
    title: '音量增加',
    blockText: `<block type="volume_add_audio"></block>`,
    content:
      '用于对音量的大小进行控制，可以为负数或正整数，负数为减小音量，正数为增加音量。',
  },
  {
    id: 'volume_set_audio',
    title: '音量设置',
    blockText: `<block type="volume_set_audio"></block>`,
    content: '将音量设定到固定值。',
  },
]

let TurtleMotion = [
  {
    rightnavs: '海龟动作',
    id: 'gta_turtle_forward',
    title: '画笔向前移动',
    content:
      '画笔前进有两种方法，前进一forward和前进二fd是效果一样的方法。',
    blockText: `<block type="gta_turtle_forward">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
    <value name="NAME2">
      <shadow type="math_number">
        <field name="NAME">100</field>
      </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_backward',
    title: '画笔后移动',
    content:
      '画笔后有三种方法，后退一backward、后退二bk、后退三back是效果一样的方法。',
    blockText: ` <block type="gta_turtle_backward">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
    <value name="NAME2">
      <shadow type="math_number">
        <field name="NAME">100</field>
      </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_rotate',
    title: '画笔旋转',
    content: `画笔针旋转一定的角度，用于改变画笔向前移动的方向；
   参数：向右表示顺时针旋转，向左表示逆时针旋转。
  `,
    blockText: `<block type="gta_turtle_rotate">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_right',
    title: '右转',
    content: `右转一right、右转二rt、是效果一样的方法。
  `,
    blockText: `<block type="gta_turtle_right">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_left',
    title: '左转',
    content: `左转一right、左转二rt、是效果一样的方法。
  `,
    blockText: `<block type="gta_turtle_left">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_goto',
    title: '画笔移动到坐标位置',
    content:
      '画笔移动到坐标位置；参数是工作台的X和Y坐标。前往一goto、前往二setpos、前往三setposition是效果一样的方法。',
    blockText: `<block type="gta_turtle_goto">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_setx_sety',
    title: '设定画笔X或Y位置',
    content: ' 分别设定画笔的X或Y坐标位置值；参数是分别X、Y对应的值',
    blockText: `<block type="gta_turtle_setx_sety">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_setheading',
    title: '画笔朝向角度',
    content:
      '设置当前朝向的角度；参数为角度值。朝向一setheading和朝向二seth是一样的方法。',
    blockText: `<block type="gta_turtle_setheading">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_home',
    title: '返回原点',
    content: '返回画笔原点（起始点）',
    blockText: `<block type="gta_turtle_home">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_circle',
    title: '画圆/圆弧',
    content: `turtle.circle(radius, extent=None, steps=None)。
      绘制一个 radius 指定半径的圆。圆心在海龟左边 radius 个单位；extent 为一个夹角，用来决定绘制圆的一部分。如未指定 extent*则绘制整个圆。如果 *extent 不是完整圆周，则以当前画笔位置为一个端点绘制圆弧。如果 radius 为正值则朝逆时针方向绘制圆弧，否则朝顺时针方向。最终海龟的朝向会依据 extent 的值而改变。`,
    blockText: `<block type="gta_turtle_circle">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_dot_2',
    title: '绘制实心点',
    content: `画笔依据直径大小绘制圆形实心点；参数：实心点直径值`,
    blockText: `<block type="gta_turtle_dot_2">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
    <value name="NAME2">
      <shadow type="text"> </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_polygon',
    title: '绘制多边形',
    content:
      ' 根据一个外接圆的大小可以确定并绘制一个正多边形；参数：n为会绘制什么多边形，外接圆的半径值确定多边形的大小。',
    blockText: `<block type="gta_turtle_polygon">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_speed',
    title: '移动速度',
    content: '设置画笔移动的速度',
    blockText: `<block type="gta_turtle_speed">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_undo',
    title: '撤销',
    content: '撤消 (或连续撤消) 最近的一个 (或多个) 海龟动作。可撤消的次数由撤消缓冲区的大小决定。',
    blockText: `<block type="gta_turtle_undo">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_reset',
    title: '重置',
    content: '从屏幕中删除海龟的绘图，海龟回到原点并设置所有变量为默认值。',
    blockText: `<block type="gta_turtle_reset">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id:'gta_turtle_write',
    title: '画笔绘制文字印章',
    content:
      ' 画笔生成文字作为文字印章；参数：文字的字体、字号、类型；参数有默认值。',
    blockText: `<block type="gta_turtle_write">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
   {
    id:'gta_turtle_pan',
    title: '画笔',
    content: '海龟库默认的画笔',
    blockText: `<block type="gta_turtle_pan"></block>`,
  },
   {
    id:'gta_turtle_position',
    title: '获取位置',
    content: '获取位置一position、位置二pos方法的效果一样',
    blockText: `<block type="gta_turtle_position">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
   {
    id:'gta_turtle_towards',
    title: '获取朝向的角度',
    content: 'turtle.towards(x, y=None)\n返回从海龟位置到由 (x,y)、矢量或另一海龟所确定位置的连线的夹角。 此数值依赖于海龟的初始朝向，这又取决于 "standard"/"world" 或 "logo" 模式设置。',
    blockText: `<block type="gta_turtle_towards">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id:'gta_turtle_cor',
    title: '返回x或y坐标',
    content: '返回当前位置的x或y坐标',
    blockText: `<block type="gta_turtle_cor">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id:'gta_turtle_heading',
    title: '获取朝向',
    content: '返回海龟当前的朝向。',
    blockText: `<block type="gta_turtle_heading">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id:'gta_turtle_distance',
    title: '获取到（x,y）位置的距离',
    content: '返回从海龟位置到由 (x,y)，适量或另一海龟对应位置的单位距离。',
    blockText: `<block type="gta_turtle_distance">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id:'gta_turtle_degrees',
    title: '设置度量单位为角度',
    content: '设置角度的度量单位，即设置一个圆周为多少 "度"。默认值为 360 度。',
    blockText: `<block type="gta_turtle_degrees">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id:'gta_turtle_radians',
    title: '设置度量单位为弧度',
    content: '设置角度的度量单位为弧度。其值等于 degrees(2*math.pi)。',
    blockText: `<block type="gta_turtle_radians">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
]
let TurtleControl = [
  {
    rightnavs: '画笔控制',
    id: 'gta_turtle_pendown',
    title: '落笔',
    content: '设置画笔为落笔状态，画笔移动绘制图形。',
    blockText: `<block type="gta_turtle_pendown">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_penup',
    title: '抬笔',
    content: '设置画笔为抬笔状态，画笔移动不绘制图形。',
    blockText: `<block type="gta_turtle_penup">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_pensize',
    title: '宽度',
    content: '设置画笔宽度',
    blockText: `<block type="gta_turtle_pensize">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_isdown',
    title: '判断画笔是否为落笔',
    content: '如果画笔落下返回 True，如果画笔抬起返回 False',
    blockText: `<block type="gta_turtle_isdown">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_color',
    title: '画笔颜色',
    content: '设置画笔颜色',
    blockText: `<block type="gta_turtle_color">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_pencolor',
    title: '画笔颜色',
    content: '设置画笔笔头颜色',
    blockText: `<block type="gta_turtle_pencolor">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_fillcolor',
    title: '笔头填充色',
    content: '设置绘制图形的填充颜色',
    blockText: `<block type="gta_turtle_fillcolor">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_filling',
    title: '画笔是否填充',
    content: '画笔是否填充',
    blockText: `<block type="gta_turtle_filling">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
   {
    id: 'gta_turtle_begin_end_fill',
    title: '开始或结束',
    content: '开始或结束填充图形',
    blockText: `<block type="gta_turtle_begin_end_fill">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  }
]
let TurtleStatus = [
  {
    rightnavs: '海龟状态',
    id: 'gta_turtle_hide_show',
    title: '显示或隐藏',
    content: '显示或隐藏画笔',
    blockText: ` <block type="gta_turtle_hide_show">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_isvisible',
    title: '是否可见',
    content: '如果海龟显示返回 True，如果海龟隐藏返回 False。',
    blockText: `<block type="gta_turtle_isvisible">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_shape',
    title: '画笔形状',
    content: '设置画笔形状；参数默认箭头',
    blockText: ` <block type="gta_turtle_shape">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_resizemode',
    title: '大小调整模式',
    content:
      '设置大小调整模式为以下值之一: "auto", "user", "noresize"。如未指定 rmode 则返回当前的大小调整模式。',
    blockText: `<block type="gta_turtle_resizemode">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_shapesize',
    title: '调整形状大小',
    content:
      '设置大小调整模式为以下值之一: "auto", "user", "noresize"。如未指定 rmode 则返回当前的大小调整模式。',
    blockText: `<block type="gta_turtle_shapesize">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_shearfactor',
    title: '剪切因子',
    content:
      '设置或返回当前的剪切因子。根据 share 指定的剪切因子即剪切角度的切线来剪切海龟形状。不 改变海龟的朝向 (移动方向)。如未指定 shear 参数: 返回当前的剪切因子即剪切角度的切线，与海龟朝向平行的线条将被剪切。',
    blockText: `<block type="gta_turtle_shearfactor">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_settiltangle',
    title: '设置倾角',
    content:
      '旋转海龟形状使其指向 angle 指定的方向，忽略其当前的倾角，不 改变海龟的朝向 (移动方向)。',
    blockText: `<block type="gta_turtle_settiltangle">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_tilt',
    title: '设置倾斜',
    content:
      '海龟形状自其当前的倾角转动 angle 指定的角度，但 不 改变海龟的朝向 (移动方向)。',
    blockText: `<block type="gta_turtle_tilt">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_shapetransform',
    title: '变形(获取变形或者设置变形)',
    content:
      '设置或返回海龟形状的当前变形矩阵。如未指定任何矩阵元素，则返回以 4 元素元组表示的变形矩阵。 否则就根据设置指定元素的矩阵来改变海龟形状，矩阵第一排的值为 t11, t12 而第二排的值为 t21, t22。 行列式 t11 * t22 - t12 * t21 必须不为零，否则会引发错误。 根据指定矩阵修改拉伸因子 stretchfactor, 剪切因子 shearfactor 和倾角 tiltangle。',
    blockText: `<block type="gta_turtle_shapetransform">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_get_shapepoly',
    title: '获取形状多边形',
    content:
      '返回以坐标值对元组表示的当前形状多边形。这可以用于定义一个新形状或一个复合形状的多个组成部分。',
    blockText: `<block type="gta_turtle_get_shapepoly">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  }
]
let TurtleScreen = [
  {
    rightnavs: '海龟窗口',
    id: 'gta_turtle_bgcolor',
    title: '设置背景颜色',
    content: '设置画面背景色',
    blockText: `<block type="gta_turtle_bgcolor"> </block>`,
  },
  {
    id: 'gta_turtle_bgpic',
    title: '背景图片',
    content:
      '设置背景图片或返回当前背景图片名称。如果 picname 为一个文件名，则将相应图片设为背景。如果 picname 为 "nopic"，则删除当前背景图片。如果 picname 为 None，则返回当前背景图片文件名。',
    blockText: `<block type="gta_turtle_bgpic">
    <value name="NAME1">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_clearscreen',
    title: '清屏',
    content:
      '从中删除所有海龟的全部绘图。将已清空的 TurtleScreen 重置为初始状态: 白色背景，无背景片，无事件绑定并启用追踪。清屏一、清屏二的方法效果一样。',
    blockText: `<block type="gta_turtle_clearscreen"> </block>`,
  },
  {
    id: 'gta_turtle_resetscreen',
    title: '重置屏幕',
    content: '重置屏幕上的所有海龟为其初始状态。一和二的方法效一致。',
    blockText: `<block type="gta_turtle_resetscreen"> </block>`,
  },
  // {
  //   id: 'gta_turtle_screensize',
  //   title: '屏幕大小',
  //   content: '重置屏幕上的所有海龟为其初始状态。一和二的方法效一致。',
  //   blockText: `<block type="gta_turtle_screensize"> </block>`,
  // },
  {
    id: 'gta_turtle_setworldcoordinates',
    title: '设置世界坐标系',
    content:
      '设置用户自定义坐标系并在必要时切换模式为 "world"。这会执行一次 screen.reset()。如果 "world" 模式已激活，则所有图形将根据新的坐标系重绘。',
    blockText: `<block type="gta_turtle_setworldcoordinates"> </block>`,
  },
  {
    id: 'gta_turtle_delay',
    title: '延迟',
    content:
      '设置或返回以毫秒数表示的延迟值 delay。(这约等于连续两次画布刷新的间隔时间。) 绘图延迟越长，动画速度越慢。',
    blockText: `<block type="gta_turtle_delay"> </block>`,
  },
  {
    id: 'gta_turtle_set_pan',
    title: '新画笔',
    content: '根据变量设置新的画笔；参数为画笔的变量',
    blockText: `<block type="gta_turtle_set_pan">
    <value name="NAME">
      <block type="variables_get">
        <field name="VAR">T</field>
      </block>
    </value>
  </block>`,
  },
   {
    id: 'gta_turtle_stamp',
    title: '画笔标记',
    content:
      ' 将画笔turtle形状的副本标记在画布上打印出来并返回其ID；无参数',
    blockText: `<block type="gta_turtle_stamp">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_turtle_clear',
    title: '清空',
    content: '删除画的内容，不修改画笔参数',
    blockText: `<block type="gta_turtle_clear">
    <value name="NAME">
      <shadow type="gta_turtle_pan"></shadow>
    </value>
  </block>`,
  },
]


export default {
  Inits,
  Events,
  Control,
  Operators,
  Text,
  List,
  Dictionary,
  Variable,
  Function,
  Media,
  TurtleMotion,
  TurtleControl,
  TurtleStatus,
  TurtleScreen,
}
